import { InputGroup } from '@blueprintjs/core';
import { DateInput } from '@blueprintjs/datetime';
import Clearfix from 'components/elements/clearfix';
import SelectCategory from 'components/elements/select-category';
import CustomDataSelect from 'components/elements/select-custom-data';
import { DATE_FORMAT } from 'config';
import { getDataForCustomSelect, ThongBaoLanData } from 'constants/custom-data';
import { LOOKUP_IDS } from 'constants/lookup-list';
import moment from 'moment';
import NumberInput from 'rc-input-number';
import React from 'react';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';
import { convertDateFromSever } from 'utils/fnUtil';
import { lookupListItemApi } from 'api/lookuplistitemApi';
import { FIELDS } from '../constants';
import { SELECT_ITEM_DEFAULT } from 'config';

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const ThongTinBCCTNH = (props) => {
  const { form, setSelInitialValue, setInitialValue } = props;

  const getHinhThucXuLy = () => {
    return lookupListItemApi.getCategory(LOOKUP_IDS.HinhThucXuLyCTNH, {
      ProvinceId: 2,
    });
  };

  return (
    <React.Fragment>
      <Row>
        <Col xs={3}>
          <LabelContainer>
            <b>Thông tin báo cáo chất thải nguy hại</b>
          </LabelContainer>
        </Col>
      </Row>

      <Row>
        <Col xs={3}>
          <LabelContainer>Mã số QLCTNH</LabelContainer>
        </Col>
        <Col xs={5}>
          <InputGroup
            placeholder='Mã số QLCTN'
            {...form.getFieldProps(FIELDS.reportHazardousWasteCode, {
              initialValue: setInitialValue(
                FIELDS.reportHazardousWasteCode,
                null
              ),
            })}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={3}>
          <LabelContainer>Ngày cấp</LabelContainer>
        </Col>
        <Col xs={5}>
          <DateInput
            formatDate={(date) => moment(date).format(DATE_FORMAT)}
            parseDate={(str) => moment(str).toDate()}
            placeholder='Ngày cấp'
            {...form.getFieldProps('reportHazardousWasteDate', {
              initialValue: convertDateFromSever(
                setInitialValue('reportHazardousWasteDate', null)
              ),
            })}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={3}>
          <LabelContainer>Cấp lần</LabelContainer>
        </Col>
        <Col xs={5}>
          <CustomDataSelect
            hideLabel
            data={ThongBaoLanData}
            fieldForm={{
              form: form,
              name: FIELDS.reportHazardousWasteAllocationTimes,
              option: {
                initialValue: getDataForCustomSelect(
                  setInitialValue(
                    FIELDS.reportHazardousWasteAllocationTimes,
                    null
                  )
                ),
              },
            }}
          />
        </Col>
      </Row>

      <Clearfix height={8} />

      <Row>
        <Col xs={3}>
          <LabelContainer>Ngày cấp lại</LabelContainer>
        </Col>
        <Col xs={5}>
          <DateInput
            formatDate={(date) => moment(date).format(DATE_FORMAT)}
            parseDate={(str) => moment(str).toDate()}
            placeholder='Ngày cấp lại'
            {...form.getFieldProps('reportHazardousWasteDateRenew', {
              initialValue: convertDateFromSever(
                setInitialValue('reportHazardousWasteDateRenew', null)
              ),
            })}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={3}>
          <LabelContainer>Hình thức xử lý</LabelContainer>
        </Col>
        <Col xs={5}>
          <SelectCategory
            getCategory={getHinhThucXuLy}
            name={FIELDS.reportHazardousWasteFormProcessing}
            initialValue={setSelInitialValue(
              FIELDS.reportHazardousWasteFormProcessing,
              SELECT_ITEM_DEFAULT
            )}
            getFieldProps={form.getFieldProps}
          />
        </Col>
      </Row>

      <Clearfix height={8} />

      <Row>
        <Col xs={3}>
          <LabelContainer>Khối lượng đăng ký (kg)</LabelContainer>
        </Col>
        <Col xs={5}>
          <NumberInput
            placeholder='Khối lượng đăng ký (kg)'
            {...form.getFieldProps('reportHazardousWasteMass', {
              initialValue: setInitialValue('reportHazardousWasteMass', ''),
            })}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ThongTinBCCTNH;



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/ChiTietCosoPanel/ChiTietCosoEdit/ThongTinBCCTNH.js